module.exports = __webpack_public_path__ + "static/Mac-Miller-FACES-9e18c21d2b33a1ade5faa34e2cb62134.png";